import RemindersEditor from './RemindersEditor'

export default RemindersEditor
